@if (data) {
  @for (platform of data["platforms"]; let i = $index; track i) {
    <div
      (click)="sharePage(platform)"
      [class]="['share__icon', 'share__icon--' + platform]"
    >
      <lg-icon [name]="platform" />
    </div>
  }
}
